var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgParticipants(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 12,
    viewBox: "0 0 15 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.212 11.3647V10.2132C10.212 9.60237 9.96939 9.01659 9.53749 8.58469C9.10559 8.15279 8.51982 7.91016 7.90902 7.91016H3.30301C2.69221 7.91016 2.10643 8.15279 1.67454 8.58469C1.24264 9.01659 1 9.60237 1 10.2132V11.3647",
    stroke: "#425364",
    strokeWidth: 1.025,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.60769 5.60601C6.87961 5.60601 7.9107 4.57492 7.9107 3.30301C7.9107 2.03109 6.87961 1 5.60769 1C4.33578 1 3.30469 2.03109 3.30469 3.30301C3.30469 4.57492 4.33578 5.60601 5.60769 5.60601Z",
    stroke: "#425364",
    strokeWidth: 1.025,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6648 11.364V10.2125C13.6644 9.70226 13.4945 9.20656 13.1819 8.80328C12.8693 8.39999 12.4316 8.11194 11.9375 7.98438",
    stroke: "#425364",
    strokeWidth: 1.025,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.63281 1.07422C10.1282 1.20106 10.5673 1.48916 10.8808 1.89312C11.1944 2.29707 11.3646 2.79389 11.3646 3.30526C11.3646 3.81662 11.1944 4.31344 10.8808 4.7174C10.5673 5.12135 10.1282 5.40946 9.63281 5.5363",
    stroke: "#425364",
    strokeWidth: 1.025,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgParticipants);
export default __webpack_public_path__ + "static/media/participants.7441629c29c60c07217b2562662d181c.svg";
export { ForwardRef as ReactComponent };